import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import ReactGA from 'react-ga'
import { connect } from 'react-redux'
import { cloneDeep, isEmpty } from 'lodash'

import {
  DatePicker,
  TimePicker,
  Loader,
  Button,
  SearchAndSelect,
  SpaceTypeSelect,
  InputField,
  Checkbox2,
  DropDown2,
  ModalStatus,
  ModalConfirm,
  TextArea,
  RepeatBooking,
  CrashMeetingModal,
  EditModal,
  EditRepeatModal,
  ModalInformation,
  Topbar,
} from '../../components'
import apiService from '../../reduxs/apiService'
import {
  PARAM_SEARCH,
  MODAL_STATUS,
  CREATE_DEFAULT,
  CREATE_BOOKING,
  DESK_BOOKING_SUBJECT,
  DESK_FLOOR_PLAN,
  TABLE,
  SPACE_TYPE,
  END_MEETING,
  NOTIFICATION_LIST,
  NOTIFICATION_TIME_LIST,
  convertBooklistToDisabledMinute,
  getDisabledHour,
  getNearestMinute,
  getLocaleDateString,
  getLocaleDateStringFull,
  countNewItems,
  countOrderItems,
  catagorizeOrder,
  catagorizeItem,
  gatherAllItem,
  gatherAllOrder,
  ROUTE,
  checkPermission,
  getRoomBookingStatus,
  STATUS,
  ROOM_STATUS,
  MAX_DROPDOWN_LIMIT,
  REPEAT_OPTION_STATUS,
  REPEAT_BOOKING,
  getRepeatResult,
  MEETING_LINK_TYPE,
  MEETING_CANNOT_BE_EDITED,
  MODAL_CONFIRM,
  COMPANY_TOKEN_TYPE,
  MENU,
} from '../../helpers'
import {
  COLOR,
  IMG,
  BUTTON_SIZE,
  FIELD,
  NATIVE_BASE_COLORS,
} from '../../themes'
import CateringModal from './CateringModal'
import RoomTimeline from './RoomTimeline'
import DeskFloorPlanModal from './DeskFloorPlanModal'
import { fetchDeskFloorPlan } from './DeskFloorPlanModal/service'
import { MODAL } from '../../reduxs'
import Style from './style'
import { GuestMultiSelect } from './GuestMultiSelect'
import RadioButton from '../../components/RadioButton'

const defaultList = []
const defaultFunction = () => { }
const btnListOrder = [{
  name: CREATE_DEFAULT.BACK,
  className: '',
  mode: 3
}, {
  name: CREATE_BOOKING.CANCEL_ORDER,
  className: 'btn-cancel',
  mode: 2
}, {
  name: CREATE_DEFAULT.SAVE,
  className: 'btn-save-pass',
  mode: 0
}]
const menuCateringList = [CREATE_BOOKING.DRINK, CREATE_BOOKING.FOOD, CREATE_BOOKING.ORDER_STATUS]
const menuEquipmentList = [CREATE_BOOKING.EQUIPMENT, '', CREATE_BOOKING.ORDER_STATUS]
const btnList = [{
  name: CREATE_DEFAULT.BACK,
  className: '',
  mode: 3
}, {
  name: CREATE_DEFAULT.DONE,
  className: 'btn-save-pass',
  mode: 1
}]

const oneHourTimeStamp = 1000 * 60 * 60
const oneDayTimeStamp = oneHourTimeStamp * 24
const timezoneOffset = new Date().getTimezoneOffset() * 1000 * 60
const timezoneOffsetHour = Math.round(new Date().getTimezoneOffset() / 60)

const MODAL_NAME = {
  CATERING: 'catering',
  EQUIPMENT: 'equipment',
  FACILITY: 'facility',
}

class CreateBooking extends React.Component {
  constructor(props) {
    super(props)
    this.initState(props)
    this.state = this.initialState

    this.timeout = 0

    //GA TrackingId
    ReactGA.initialize("UA-153387162-1")
    ReactGA.pageview("Create Booking Page")
  }

  componentDidMount() {
    this.unblock = this.props.history.block((location, action) => {
      if (location.pathname === this.props.location.pathname) {
        return true
      }
      if (this.hasUnsavedChanges()) {
        this.setState({ isShowUnsavedModal: true, nextLocation: location })
        return false
      }
      return true
    })
    window.addEventListener('keydown', this.handleKeyDown)
    if (!this.props.params.bookingId && !this.props.query.roomId) {
      this.initialStateString = JSON.stringify(this.getFormState())
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true
    if (this.unblock) this.unblock()
    window.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = (e) => {
    const isRefresh = e.key === 'F5' || ((e.ctrlKey || e.metaKey) && e.key === 'r')
    if (isRefresh && this.hasUnsavedChanges()) {
      e.preventDefault()
      this.setState({ isShowUnsavedModal: true, nextLocation: null, isRefreshAction: true })
    }
  }

  getFormState = () => {
    const { state } = this
    
    const addedCatering = gatherAllItem([state.itemCatering]).filter(i => i.amount > 0).map(i => ({ id: i.itemId, amount: i.amount }))
    const addedEquipment = gatherAllItem([state.itemEquipment]).filter(i => i.amount > 0).map(i => ({ id: i.itemId, amount: i.amount }))
    
    let currentOrderCatering = []
    if (state.orderCatering) {
      state.orderCatering.forEach(order => {
        if (order.items) {
          order.items.forEach(i => {
            if (i.amount > 0) currentOrderCatering.push({ id: i.itemId, amount: i.amount })
          })
        }
      })
    }
    
    let currentOrderEquipment = []
    if (state.orderEquipment) {
      state.orderEquipment.forEach(order => {
        if (order.items) {
          order.items.forEach(i => {
            if (i.amount > 0) currentOrderEquipment.push({ id: i.itemId, amount: i.amount })
          })
        }
      })
    }

    return {
      selectedCompany: state.selectedCompany,
      selectedBuilding: state.selectedBuilding,
      selectedFloor: state.selectedFloor,
      selectedRoom: state.selectedRoom,
      spaceType: state.spaceType,
      projectName: state.projectName,
      bookingDetail: state.bookingDetail,
      guest: state.guest,
      itemCatering: addedCatering,
      itemEquipment: addedEquipment,
      orderCatering: currentOrderCatering,
      orderEquipment: currentOrderEquipment,
      recurrence: state.recurrence,
      notification: state.notification,
      notificationTime: state.notificationTime,
      isPrivate: Boolean(state.isPrivate),
      selectedDate: state.selectedDate ? `${state.selectedDate.getFullYear()}-${state.selectedDate.getMonth() + 1}-${state.selectedDate.getDate()}` : null,
      selectedStartTime: state.selectedStartTime ? `${state.selectedStartTime.getHours()}:${state.selectedStartTime.getMinutes()}` : null,
      selectedEndTime: state.selectedEndTime ? `${state.selectedEndTime.getHours()}:${state.selectedEndTime.getMinutes()}` : null,
      meetingLink: state.meetingLink,
      meetingLinkType: state.meetingLinkType,
      isOnlineMeeting: state.isOnlineMeeting
    }
  }

  hasUnsavedChanges = () => {
    if (this.isSaving) return false
    if (!this.state.isEditable) return false
    return JSON.stringify(this.getFormState()) !== this.initialStateString
  }

  confirmNavigation = () => {
    if (this.unblock) this.unblock()
    this.setState({ isShowUnsavedModal: false }, () => {
      if (this.state.isRefreshAction) {
        window.location.reload()
      } else if (this.state.nextLocation) {
        this.props.history.push(this.state.nextLocation.pathname)
      } else {
        this.props.history.goBack()
      }
    })
  }

  cancelNavigation = () => {
    this.setState({ isShowUnsavedModal: false, nextLocation: null, isRefreshAction: false })
  }

  componentDidUpdate (prevProps) {
    const {
      minuteStep = 15,
      startOperatingTime = '00:00:00',
      endOperatingTime = '23:59:59',
      username,
    } = this.props

    if (prevProps && this.props.query && prevProps.query && this.props.query.date !== prevProps.query.date) {
      const newDateStr = this.props.query.date;
      if (newDateStr) {
        const newDate = new Date(newDateStr);
        if (!isNaN(newDate.getTime())) {
          this.setState(prevState => {
            const nextSelectedDate = new Date(prevState.selectedDate);
            nextSelectedDate.setFullYear(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
            
            const nextStartTime = new Date(prevState.selectedStartTime);
            nextStartTime.setFullYear(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
            
            const nextEndTime = new Date(prevState.selectedEndTime);
            nextEndTime.setFullYear(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
            
            return {
              selectedDate: nextSelectedDate,
              selectedStartTime: nextStartTime,
              selectedEndTime: nextEndTime
            };
          }, () => {
            try {
              if (this.initialStateString) {
                const currentInit = JSON.parse(this.initialStateString);
                currentInit.selectedDate = this.state.selectedDate;
                currentInit.selectedStartTime = this.state.selectedStartTime;
                currentInit.selectedEndTime = this.state.selectedEndTime;
                this.initialStateString = JSON.stringify(currentInit);
              }
            } catch (e) {}
          });
        }
      }
    }
    if (!this.initialState.id > 0 &&
      !this.initialState.selectedRoom &&
      (this.initialState.minuteStep !== minuteStep ||
        this.initialState.startOperatingTime !== startOperatingTime ||
        this.initialState.endOperatingTime !== endOperatingTime)
    ) return this.initState(this.props, true)
    if (
      this.state.currentUser !== username &&
      this.state.selectedOwner.username === username
    ) {
      this.setState({
        canEdit: true,
        currentUser: username,
      })
    }

    const deskFloorId = this.state.selectedFloor ? this.state.selectedFloor.id : null
    if (deskFloorId && deskFloorId !== this.state.deskFloorPlan.floorId) {
      this.loadDeskFloorPlan(deskFloorId)
    }
  }

  loadDeskFloorPlan (floorId) {
    this.setState({ deskFloorPlan: { floorId, status: 'loading', data: null } })

    fetchDeskFloorPlan(floorId)
      .catch(() => null)
      .then((data) => {
        if (this.isUnmounted || this.state.deskFloorPlan.floorId !== floorId) return
        this.setState((prevState) => ({
          deskFloorPlan: { floorId, status: data ? 'ready' : 'unavailable', data },
          isShowDeskFloorPlanModal: Boolean(data) && prevState.isShowDeskFloorPlanModal,
        }))
      })
  }

  openDeskFloorPlanModal = () => {
    this.setState({ isShowDeskFloorPlanModal: true })
  }

  closeDeskFloorPlanModal = () => {
    this.setState({ isShowDeskFloorPlanModal: false })
  }

  selectDeskFromFloorPlan = ({ desk, date, startTime }) => {
    this.setState((prevState) => {
      const duration = prevState.selectedStartTime && prevState.selectedEndTime
        ? prevState.selectedEndTime - prevState.selectedStartTime
        : 0
      let endTime = new Date(startTime.valueOf() + (duration > 0 ? duration : 60 * 60000))

      if (endTime.getDate() !== startTime.getDate()) {
        endTime = new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate() + 1, 0, -prevState.minuteStep)
      }

      return {
        selectedRoom: { id: desk.id, name: desk.name, checkInRequired: desk.checkInRequired },
        roomText: desk.name,
        selectedDate: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
        selectedStartTime: startTime,
        selectedEndTime: endTime > startTime ? endTime : null,
        itemCatering: null,
        itemEquipment: null,
        roomList: [],
        isShowRoomTimeline: false,
        isShowDeskFloorPlanModal: false,
      }
    })
  }

  initState (props, doUpdate = false) {
    const now = new Date().valueOf()
    const todayTimestamp = Math.floor(now / oneDayTimeStamp) * oneDayTimeStamp
    let selectedDate = this.initDatetime(
      props.query.date
        ? new Date(props.query.date)
        : new Date()
    )
    if (isNaN(selectedDate.valueOf()) || selectedDate.valueOf() < todayTimestamp) selectedDate = new Date(todayTimestamp)
    let selectedStartTime = this.initDatetime(
      props.query.startTime && props.query.date
        ? new Date(`${props.query.date} ${props.query.startTime}:00`)
        : new Date(new Date(selectedDate.valueOf() + (new Date().valueOf() % oneDayTimeStamp)))
    )
    if (isNaN(selectedStartTime.valueOf()) || selectedStartTime < new Date(now - 900000)) selectedStartTime = this._selectDate(new Date()).selectedStartTime
    else if (selectedStartTime.getHours() === 23 && selectedStartTime.getMinutes() === 45) selectedStartTime = new Date(selectedDate.valueOf() + oneDayTimeStamp - 1800000 + timezoneOffset)
    let selectedEndTime = this.initDatetime(
      props.query.endTime && props.query.date
        ? new Date(`${props.query.date} ${props.query.endTime}:00`)
        : new Date(selectedStartTime.valueOf() + oneHourTimeStamp)
    )
    if (isNaN(selectedEndTime.valueOf())) {
      selectedEndTime = new Date(selectedStartTime.valueOf() + oneHourTimeStamp)
    } else if (selectedEndTime < new Date(now - 900000)) {
      selectedEndTime = new Date(selectedStartTime.valueOf() + oneHourTimeStamp)
    } else if (selectedEndTime < selectedStartTime) {
      selectedEndTime = new Date(selectedStartTime.valueOf() + oneHourTimeStamp)
    }
    if (selectedStartTime.getDate() !== selectedEndTime.getDate()) {
      selectedEndTime = new Date(selectedDate.valueOf() + oneDayTimeStamp - 900000 + timezoneOffset)
    }

    this.initialState = {
      id: -1,
      currentUser: props.username,
      minuteStep: props.minuteStep ? props.minuteStep : 15,
      startOperatingTime: props.startOperatingTime ? props.startOperatingTime : '00:00:00',
      endOperatingTime: props.endOperatingTime ? props.endOperatingTime : '23:59:59',
      companyText: '',
      buildingText: '',
      floorText: '',
      roomText: '',
      ownerText: '',
      guestText: '',
      selectedCompany: null,
      selectedBuilding: null,
      selectedFloor: null,
      selectedRoom: null,
      selectedDate: selectedDate,
      selectedStartTime: selectedStartTime,
      selectedEndTime: selectedEndTime,
      selectedOwner: { 
        username: props.username,
        name: props.dataUser.name,
      },
      projectName: '',
      isPrivate: false,
      notification: NOTIFICATION_LIST[props.language][0],
      notificationTime: NOTIFICATION_TIME_LIST[0],
      bookingDetail: '',
      recurrence: null,
      recurrenceText: REPEAT_BOOKING.OFF[props.language],
      previousRecurrence: null,
      clearRecurrence: null,
      selectableTime: null,
      isEditing: false,
      status: 2,
      isError: false,
      itemCatering: null,
      itemEquipment: null,
      orderCatering: [],
      orderEquipment: [],
      isShowDatePicker: false,
      isShowStartTimePicker: false,
      isShowEndTimePicker: false,
      isShowCateringModal: false,
      isShowEquipmentModal: false,
      isShowRoomTimeline: false,
      isLoading: true,
      isHiding: true,
      canEdit: true,
      lockRoom: false,
      companyList: [],
      buildingList: [],
      floorList: [],
      roomList: [],
      bookingList: [],
      guest: [],
      selectGuestList: [],
      userList: [],
      guestSearchKeyword: '',
      isSearchingGuest: false,
      order: [],
      countEquipment: 0,
      countCatering: 0,
      showModalEndMeeting: false,
      isOpenSuggestRoom: false,
      isOpenSuggestBuilding: false,
      isOpenSuggestFloor: false,
      isFocusGuest: false,
      meetingLink: '',
      meetingLinkType: MEETING_LINK_TYPE.NONE,
      isOnlineMeeting:false,
      previousMeetingLinkType: MEETING_LINK_TYPE.AUTO,
      listHoliday: props.listHoliday,
      isOpenRepeatModal: false,
      isOpenEditModal: false,
      isOpenEditRepeatModal: false,
      selectedKeyRepeatOption: REPEAT_OPTION_STATUS.THIS_SCHEDULE,
      force: false,
      spaceType: SPACE_TYPE.ROOM,
      isDisabledSaveButton: false,
      isEditable: true,
      deskFloorPlan: { floorId: null, status: null, data: null },
      isShowDeskFloorPlanModal: false,
    }
    if (props.params.bookingId && !isNaN(props.params.bookingId)) {
      this.getDetailBooking()
    } else if (props.query.roomId) {
      this.getDetailRoom(props.query.roomId)
    } else {
      this.initialState.isLoading = false
      this.initialState.isHiding = false
    }
    if (doUpdate) {
      this.setState(this.initialState)
    }

    const day = new Date(selectedDate)
    const year = day.getFullYear()
    const month = day.getMonth()
    const countDay = new Date(year, month + 1, 0)
    this.getListHoliday({ year, month, countDay: countDay.getDate() })
  }
  
  goBack = () => {
    const { history, query } = this.props
    if (query && query.returnTo) {
      if (window.history.length > 1) {
        history.goBack()
      } else {
        history.replace(query.returnTo)
      }
      return
    }
    if (query && query.from && this.state.selectedDate) {
      const year = this.state.selectedDate.getFullYear()
      const month = this.state.selectedDate.getMonth() + 1
      const date = this.state.selectedDate.getDate()
      const dateQuery = `?date=${year}/${month}/${date}`
      
      if ((query.from === 'meetingroom_detail' || query.from === 'meetingroom_timeline') && query.roomId) {
        history.replace(`${ROUTE.MEETING_ROOM.DETAIL}/${query.roomId}${dateQuery}`)
        return
      } else if (query.from === 'floorplan_timeline' && query.roomId) {
        history.replace(`${ROUTE.FLOORPLAN.CALENDAR}/${query.roomId}/${year}/${month}/${date}`)
        return
      } else if (query.from === 'floorplan') {
        history.replace(this.getFloorPlanPath(this.state.selectedDate))
        return
      } else if (query.from.startsWith('calendar_')) {
        const view = query.from.replace('calendar_', '') || 'month'
        history.replace(`${ROUTE.CALENDAR.LINK}/${view}/${year}/${month}/${date}`)
        return
      }
    }
    history.goBack()
  }

  getFloorPlanPath = (date) => {
    const { query } = this.props
    const path = `${ROUTE.FLOORPLAN.LINK}/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    if (query && query.buildingId && query.floorId) {
      const timeQuery = query.time ? `&time=${query.time}` : ''
      return `${path}?buildingId=${query.buildingId}&floorId=${query.floorId}${timeQuery}`
    }
    return path
  }

  initDatetime (selectedDate) {
    const minuteStep = this.state && this.state.selectedRoom ? this.state.minuteStep : this.props.minuteStep
    let minute = getNearestMinute(selectedDate.getMinutes(), minuteStep, 1)
    let hour = selectedDate.getHours() + timezoneOffsetHour
    let now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour, minute)

    if (minute >= 60) {
      minute = 0
      hour = hour + 1
      if (hour >= 24) {
        now = null
      }
    }

    if (now !== null) now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour - timezoneOffsetHour, minute)
    return now
  }

  getDetailBooking () {
    const { username } = this.props
    apiService.get('rest/v1/getdetail_booking', {
      bookingId: this.props.params.bookingId
    }).then((res) => {
      if (res.status) {
        const booking = res.data
        const catagorizedOrder = catagorizeOrder(booking.orders)
        let minuteStep = this.props.minuteStep
        try {
          minuteStep = booking.minuteStep
        } catch (_) {
          
        }
        const startDatetimestamp = new Date(booking.startDatetime).valueOf()
        let notiIndex = NOTIFICATION_TIME_LIST.indexOf(booking.notificationTime)
        notiIndex = notiIndex < 0 ? 0 : notiIndex
        const isOwner = booking.owner.username === username
        const hasGuest = Boolean(
          booking.guest.find(
            ({ username: guestUsername }) => guestUsername === username
            )
            )
            Object.assign(this.initialState, booking, {
              id: booking.bookingId,
              orderCatering: catagorizedOrder[1],
              orderEquipment: catagorizedOrder[2],
              countCatering: countOrderItems(catagorizedOrder[1]),
              countEquipment: countOrderItems(catagorizedOrder[2]),
              notification: NOTIFICATION_LIST[this.props.language][notiIndex],
              notificationTime: NOTIFICATION_TIME_LIST[notiIndex],
              minuteStep: minuteStep,
              selectedRoom: {
                id: booking.roomId,
                name: booking.roomName
              },
              selectedCompany: {
                id: booking.companyId,
                name: booking.companyName
              },
              selectedBuilding: {
                id: booking.buildingId,
                name: booking.buildingName
              },
              selectedFloor: {
                id: booking.floorId,
                name: booking.floorLevel
              },
              roomText: booking.roomName,
              buildingText: booking.buildingName || '',
              floorText: booking.floorLevel || '',
              selectedOwner: {
                username: booking.owner.username,
                name: booking.owner.name,
              },
              isEditing: true,
              canEdit: isOwner || hasGuest,
              selectedDate: new Date(Math.floor(new Date(startDatetimestamp) / oneDayTimeStamp) * oneDayTimeStamp),
              selectedStartTime: new Date(startDatetimestamp + timezoneOffset),
              selectedEndTime: new Date(new Date(booking.endDatetime).valueOf() + timezoneOffset),
              isLoading: false,
              isHiding: false,
              bookingDetail: booking.description,
              guestCurrent: booking.guest,
              meetingLink: booking.meetingLink || '-',
              meetingLinkType: booking.meetingLinkType,
              isOnlineMeeting: (booking.meetingLinkType || MEETING_LINK_TYPE.NONE) !== MEETING_LINK_TYPE.NONE,
              previousRecurrence: booking.recurrence,
              clearRecurrence: booking.recurrence,
              isEditable: booking.isEditable
        })
        this.setState(this.initialState, () => {
          this.initialStateString = JSON.stringify(this.getFormState())
        })
      } else if (!res.status) {
        this.props.openModalStatus({ ...res, doGoBack: true })
      } else {
        console.log('ERROR ACTION getListAllBooking2', res)
      }
    })
  }
  
  getDetailRoom (roomId) {
    apiService.get('rest/v1/getdetail_room', {
      roomId: roomId
    }).then((res) => {
      if (res.status) {
        const room = res.data
        let minuteStep = this.props.minuteStep
        try {
          minuteStep = room.minuteStep
        } catch (_) {

        }
        Object.assign(this.initialState, {
          minuteStep: minuteStep,
          selectedRoom: {
            id: room.roomId,
            name: room.roomName
          },
          selectedCompany: {
            id: room.companyId,
            name: room.companyName
          },
          selectedBuilding: {
            id: room.buildingId,
            name: room.buildingName
          },
          selectedFloor: {
            id: room.floorId,
            name: room.floorLevel
          },
          roomText: room.roomName,
          buildingText: room.buildingName || '',
          floorText: room.floorLevel || '',
          spaceType: room.spaceType || 'room',
          lockRoom: true,
          isLoading: false,
          isHiding: false,
          startOperatingTime: room.startOperatingTime,
          endOperatingTime: room.endOperatingTime
        })
        this.setState(this.initialState, () => {
          this.initialStateString = JSON.stringify(this.getFormState())
        })
      } else if (!res.status) {
        this.props.openModalStatus(res)
        this.setState({
          isLoading: false,
          isHiding: false
        })
      } else {
        console.log('ERROR ACTION getListAllBooking2', res)
      }
    })
  }

  isDeskBooking (state = this.state) {
    return state.spaceType === SPACE_TYPE.DESK
  }

  validateInput () {
    const state = Object.assign({}, this.state)
    const props = Object.assign({}, this.props)
    
    if (state.selectedCompany == null && !props.dataUser.companyId) { return false; }
    if (state.selectedBuilding == null) { return false; }
    if (state.selectedFloor == null) { return false; }
    if (state.selectedRoom == null) { return false; }
    if (state.selectedOwner == null) { return false; }
    if (state.notificationTime == null) { return false; }
    if (state.selectedDate == null) { return false; }
    if (state.selectedEndTime == null) { return false; }
    if (state.selectedStartTime == null) { return false; }
    if (state.isPrivate == null) { return false; }
    if (state.guest == null) { return false; }
    if (!this.isDeskBooking(state) && !state.projectName) { return false; }
    if (state.isEditing && state.id < 0) { return false; }
    if (props.username == null) { return false; }
    
    return true
  }

  setRecurrence (recurrence) {
    const { isEditing } = this.state
    let recurrenceParams
  
    if (isEditing) {
      recurrenceParams = !isEmpty(recurrence) ? { recurrence } : { recurrence: null }
    } else {
      recurrenceParams = recurrence ? { recurrence } : {}
    }
    
    return recurrenceParams
  }

  isRecurrenceUpdateValue = false

  prepareParams (isRecurrenceUpdate) {
    const { recurrence, isEditing } = this.state
    const state = Object.assign({}, this.state)
    const dateString = [state.selectedDate.getFullYear(), (state.selectedDate.getMonth() + 1).toString().padStart(2, 0), state.selectedDate.getDate().toString().padStart(2, 0)].join('-')
    const startTimeString = [state.selectedStartTime.getHours().toString().padStart(2, 0), state.selectedStartTime.getMinutes().toString().padStart(2, 0), '00'].join(':')
    const endTimeString = [state.selectedEndTime.getHours().toString().padStart(2, 0), state.selectedEndTime.getMinutes().toString().padStart(2, 0), '00'].join(':')

    const startDatetime = [dateString, startTimeString].join(' ')
    const endDatetime = [dateString, endTimeString].join(' ')

    const recurrenceParams = this.setRecurrence(recurrence)

    const params = {
      companyId: state.selectedCompany ? state.selectedCompany.id : this.props.dataUser.companyId,
      buildingId: state.selectedBuilding.id,
      floorId: state.selectedFloor.id,
      roomId: state.selectedRoom.id,
      isPrivate: state.isPrivate,
      startDatetime,
      endDatetime,
      owner: state.selectedOwner,
      guest: state.guest.map(res => {
        delete res.profileThumbnail
        return res
      }),
      notificationTime: state.notificationTime,
      projectName: this.isDeskBooking(state)
        ? state.projectName || DESK_BOOKING_SUBJECT
        : state.projectName,
      description: state.bookingDetail,
      items: gatherAllItem([state.itemCatering, state.itemEquipment]),
      meetingLink: state.meetingLink,
      meetingLinkType: state.meetingLinkType,
      force: state.force,
      ...recurrenceParams,
    }

    this.isRecurrenceUpdateValue = isRecurrenceUpdate ?? this.isRecurrenceUpdateValue
    if (isEditing) {
      params.isRecurrenceUpdate = this.isRecurrenceUpdateValue
    }

    if (state.id > 0) {
      params.bookingId = state.id
    }
    
    return params
  }

  raiseError () {
    const { selectedRoom } = this.state
    const { language, openModalStatus } = this.props
    const projectName = this.isDeskBooking() || this.state.projectName

    let descriptionError1 = CREATE_DEFAULT.TEXT_ERROR_1[language]
    let descriptionError2 = CREATE_DEFAULT.TEXT_ERROR_2[language]
    if (selectedRoom && !projectName) {
      descriptionError1 = CREATE_DEFAULT.TEXT_ERROR_PROJECT_NAME[language]
      descriptionError2 = ''
    }
    if (!selectedRoom && projectName) {
      descriptionError1 = CREATE_DEFAULT.TEXT_ERROR_MEETING_ROOM_NAME[language]
      descriptionError2 = ''
    }

    this.setError()
    openModalStatus({
      data: {
        description: descriptionError2 ? `${descriptionError1}\n${descriptionError2}` : descriptionError1
      }
    })
  }

  getNowMinusStep (step, selectedDate = new Date(), time) {
    const nowTimestamp = new Date().valueOf()
    const minuteStep = step * 60000

    if (time) {
      const timeDatetime = new Date(`${selectedDate.getFullYear()}/${(selectedDate.getMonth() + 1).toString().padStart('0', 2)}/${selectedDate.getDate().toString().padStart('0', 2)} ${time}`)
      if (timeDatetime.valueOf() > nowTimestamp) {
        return new Date(
          Math.floor(timeDatetime.valueOf() / 60000) * 60000
        )
      }
    }

    return new Date((Math.floor(nowTimestamp / minuteStep) * minuteStep))
  }

  handleDoneCatering (mode, itemList) {
    const amountItem = countNewItems(itemList)
    let amountOrderItems = 0
    switch (mode) {
      case 1:
        amountOrderItems = countOrderItems(this.state.orderCatering)
        this.setState({
          itemCatering: itemList,
          countCatering: amountOrderItems + amountItem,
          isShowCateringModal: false,
          isShowEquipmentModal: false
        })
        break
      case 2:
        amountOrderItems = countOrderItems(this.state.orderEquipment)
        this.setState({
          itemEquipment: itemList,
          countEquipment: amountOrderItems + amountItem,
          isShowCateringModal: false,
          isShowEquipmentModal: false
        })
        break
      default:
        break
    }
  }

  handleCancelCatering (mode, orderList) {
    let oldOrderList = []
    switch (mode) {
      case 1:
        oldOrderList = this.state.orderCatering.slice()
        break
      case 2:
        oldOrderList = this.state.orderEquipment.slice()
        break
      default:
        return null
    }
    const leftOverOrder = []
    orderList.forEach((order, i) => {
      if (order.status > 0) {
        const items = order.items
        const oldItems = oldOrderList[i].items
        const leftOverItem = []
        items.forEach((item, j) => {
          if (!item.isChecked) {
            leftOverItem.push(oldItems[j])
          }
        })
        oldOrderList[i].items = leftOverItem
        leftOverOrder.push(oldOrderList[i])
      } else {
        leftOverOrder.push(oldOrderList[i])
      }
    })
    this.handleSaveCatering(mode, leftOverOrder)
  }

  handleSaveCatering (mode, orderList) {
    for (const order of orderList) {
      order.isChecked = false
      for (const item of order.items) {
        item.isChecked = false
      }
    }
    let func = defaultFunction
    switch (mode) {
      case 1:
        orderList = gatherAllOrder(orderList, this.state.orderEquipment)
        func = (_orderList) => this.setState({
          orderCatering: _orderList[1],
          countCatering: countOrderItems(_orderList[1]) + countNewItems(this.state.itemCatering),
          countEquipment: countOrderItems(this.state.orderEquipment) + countNewItems(this.state.itemEquipment),
          isShowCateringModal: false,
          isShowEquipmentModal: false
        })
        break
      case 2:
        orderList = gatherAllOrder(orderList, this.state.orderCatering)
        func = (_orderList) => this.setState({
          orderEquipment: _orderList[2],
          countCatering: countOrderItems(this.state.orderCatering) + countNewItems(this.state.itemCatering),
          countEquipment: countOrderItems(_orderList[2]) + countNewItems(this.state.itemEquipment),
          isShowCateringModal: false,
          isShowEquipmentModal: false
        })
        break
      default:
        break
    }
    if (this.state.id) {
      apiService.post('rest/v1/update_order', {
        bookingId: this.state.id,
        orders: orderList
      }).then((res) => {
        this.setState({
          isLoading: false
        })
        if (res.status) {
          func(catagorizeOrder(res.data))
          this.props.openModalStatus(res)
        } else if (!res.status) {
          this.props.openModalStatus(res)
        } else {
          console.log('ERROR ACTION createBuilding', res)
        }
      })
    } else {
      this.displayError(CREATE_BOOKING.BOOKING_NOT_FOUND[this.props.language])
    }
  }

  setError () {
    this.setState({
      isError: true
    })
  }

  searchRoom (text) {
    this.setState({
      selectedRoom: null,
      roomText: text,
      itemCatering: null,
      itemEquipment: null,
      isShowRoomTimeline: false,
      isError: false,
      isLoading: true,
    })
    const { selectedDate, selectedStartTime, selectedEndTime, spaceType } = this.state
    const { companyId } = this.props.dataUser
    const formattedDate = moment(selectedDate).format('YYYY-MM-DD')
    const formattedStartTime = moment(selectedStartTime).format('HH:mm:ss.SSS')
    const formattedEndTime = moment(selectedEndTime).format('HH:mm:ss.SSS')
    const params = {
      companyId,
      buildingId: this.state.selectedBuilding ? this.state.selectedBuilding.id : undefined,
      trashed: false,
      limit: 100,
      page: 1,
      status: ROOM_STATUS.ACTIVE,
      startDatetime: `${formattedDate} ${formattedStartTime}`,
      endDatetime: `${formattedDate} ${formattedEndTime}`,
      floorId: this.state.selectedFloor ? this.state.selectedFloor.id : undefined,
      spaceType,
      roomName: (text || '').trim() || undefined,
    }
    const requestId = (this.roomRequestId || 0) + 1
    this.roomRequestId = requestId
    apiService.get('rest/v2/room', params).then((res) => {
      if (requestId !== this.roomRequestId) return
      if (res.status && res.data) {
        this.setState({
          roomList: res.data.list.map((room) => {
            return {
              ...room,
              id: room.id,
              name: room.name,
              isAvailable: room.isUsing === 0,
            }
          }),
        })
      }
      if (!res.status) {
        this.props.openModalStatus(res)
      }
      this.setState({ isLoading: false })
    })
  }

  searchGuest (value) {
    const keyword = value.trim()
    this.setState({ guestText: value })

    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      const requestId = (this.guestSearchRequestId || 0) + 1
      this.guestSearchRequestId = requestId
      this.setState({ isSearchingGuest: true })
      apiService.get('rest/v1/getlist_user2', {
        keyword,
        username: keyword,
        trashed: false
      }).then((res) => {
        if (requestId !== this.guestSearchRequestId) return
        this.setState({ isSearchingGuest: false })
        if (res.status) {
          if (keyword !== this.state.guestText.trim()) return
          this.setState({
            userList: res.data.list,
            guestSearchKeyword: keyword
          })
        } else if (!res.status) {
          this.props.openModalStatus(res)
        } else {
          console.log('ERROR searchGuest', res)
        }
      })
    }, keyword ? 500 : 0)
  }

  selectRoom (room) {
    if (this.state.canEdit && this.state.status !== 0) {
      this.setState({
        selectedRoom: {
          id: room.id,
          name: room.name,
          checkInRequired: room.checkInRequired
        },
        roomText: room.name,
        itemCatering: null,
        itemEquipment: null,
        roomList: [],
        isShowRoomTimeline: false,
        minuteStep: room.company ? room.company.minuteStep : room.minuteStep,
        startOperatingTime: room.company ? room.company.startOperatingTime : room.startOperatingTime,
        endOperatingTime: room.company ? room.company.endOperatingTime : room.endOperatingTime
      })
    }
  }

  selectGuest (guest) {
    const guestList = this.state.guest.slice()
    this.setState({
      guest: guestList.concat(guest),
      guestText: '',
      userList: [],
      isFocusGuest: false
    })
  }

  searchBuilding = (text) => {
    this.setState({
      selectedBuilding: null,
      buildingText: text,
      floorText: '',
      selectedFloor: null,
      roomText: '',
      selectedRoom: null,
      floorList: [],
      roomList: [],
      isLoading: true,
    })
    
    const { dataUser } = this.props
    
    apiService.get('rest/v1/getlist_building2', {
      ...PARAM_SEARCH.BUILDING,
      trashed: false,
      limit: MAX_DROPDOWN_LIMIT,
      buildingName: text || ' ',
      companyId: dataUser.companyId,
      ordering: 'buildingName ASC',
    }).then((res) => {
      if (res.status && res.data) {
        this.setState({
          buildingList: res.data.list.map((building) => ({
            id: building.buildingId,
            name: building.buildingName,
          })),
        })
      }
      this.setState({ isLoading: false })
    })
  }

  selectBuilding = (building) => {
    this.setState({
      selectedBuilding: building,
      buildingText: building.name,
      floorText: '',
      selectedFloor: null,
      roomText: '',
      selectedRoom: null,
      roomList: [],
    })
  }

  deselectBuilding = () => {
    this.setState({
      selectedBuilding: null,
      buildingText: '',
      floorText: '',
      selectedFloor: null,
      roomText: '',
      selectedRoom: null,
      floorList: [],
      roomList: [],
    })
  }

  searchFloor = (text) => {
    const { selectedBuilding } = this.state
    const { dataUser } = this.props

    this.setState({
      selectedFloor: null,
      floorText: text,
      roomText: '',
      selectedRoom: null,
      roomList: [],
      isLoading: true,
    })

    const number = parseInt(text)
    apiService.get('rest/v1/getlist_floor2', {
      ...PARAM_SEARCH.FLOOR,
      trashed: false,
      limit: MAX_DROPDOWN_LIMIT,
      floorLevel: text || ' ',
      buildingId: selectedBuilding ? selectedBuilding.id : undefined,
      companyId: dataUser.companyId,
      ordering: 'floorLevel ASC',
    }).then((res) => {
      if (res.status && res.data) {
        this.setState({
          floorList: res.data.list.map((floor) => ({
            id: floor.floorId,
            name: floor.floorLevel,
          })),
        })
      }
      this.setState({ isLoading: false })
    })
  }

  selectFloor = (floor) => {
    this.setState({
      selectedFloor: floor,
      floorText: floor.name,
      roomText: '',
      selectedRoom: null,
    })
  }

  deselectFloor = () => {
    this.setState({
      selectedFloor: null,
      floorText: '',
      roomText: '',
      selectedRoom: null,
      roomList: [],
    })
  }

  handleSpaceTypeChange = (spaceType) => {
    // Desk hides these fields, so drop anything typed before switching (new bookings only)
    const isResetForDesk = spaceType && spaceType.id === SPACE_TYPE.DESK && !this.state.isEditing
    this.setState({ 
      spaceType: spaceType ? spaceType.id : null, 
      roomText: '', 
      selectedRoom: null, 
      roomList: [],
      ...(isResetForDesk && {
        projectName: '',
        isPrivate: false,
        guest: [],
        selectGuestList: [],
        guestText: '',
        meetingLink: '',
        meetingLinkType: MEETING_LINK_TYPE.NONE,
        isOnlineMeeting: false,
        itemCatering: null,
        itemEquipment: null,
      }),
    })
  }

  deselectRoom () {
    this.setState({
      selectedRoom: null,
      roomText: '',
      itemCatering: null,
      itemEquipment: null,
      roomList: [],
      isShowRoomTimeline: false,
      minuteStep: this.props.minuteStep,
      startOperatingTime: this.props.startOperatingTime,
      endOperatingTime: this.props.endOperatingTime
    })
  }

  deselectGuest (index) {
    const _guestList = this.state.guest.slice()
    _guestList.splice(index, 1)
    this.setState({
      guest: _guestList.slice(),
      guestText: ''
    })
  }

  setPreviousRecurrence = (newRecurrence) => {
    this.setState({ previousRecurrence: newRecurrence })
  }

  getResultText = (recurrence, language) => {
    return recurrence
      ? getRepeatResult(recurrence, language)
      : REPEAT_BOOKING.OFF[language]
  }

  setRecurrenceText = (recurrence, language) => {
    this.setState({ recurrenceText: this.getResultText(recurrence, language) })
  }

  repeatBooking = () => {
    const { 
      recurrence,
      selectedDate,
      selectedStartTime,
      isOpenRepeatModal,
      previousRecurrence,
      recurrenceText,
      status,
      isEditable
    } = this.state
    
    const { language, listHoliday, settingReducer } = this.props  
    const { colorTheme } = settingReducer.settingTheme
    
    const onShowRepeatBooking = (isOpenRepeatModal) => {
      this.setState({ isOpenRepeatModal })
    }

    const setRecurrence = (data) => {
      this.setState({ recurrence: data })
    }

    return (
      <RepeatBooking
        colorTheme={colorTheme}
        isVisible={isOpenRepeatModal}
        language={language}
        recurrence={recurrence}
        date={selectedDate}
        startTime={selectedStartTime}
        setRecurrence={setRecurrence}
        recurrenceText={recurrenceText}
        previousRecurrence={previousRecurrence}
        setPreviousRecurrence={this.setPreviousRecurrence}
        setRecurrenceText={this.setRecurrenceText}
        onShowRepeatBooking={onShowRepeatBooking}
        getHolidays={this.getListHoliday}
        holidays={listHoliday}
        disabled={status !== STATUS.NOT_YET_TIME_MEETING || !isEditable}
      />
    )
  }

  crashMeetingModal = () => {
    const { isEditing: isEditBooking } = this.state
    const { language, isOpenCrashMeetingModal, onCloseCrashMeetingModal, settingReducer } = this.props
    const { colorTheme } = settingReducer.settingTheme

    const onChangeDates = () => {
      this.setState({
        isOpenRepeatModal: true,
      }, () => onCloseCrashMeetingModal())
    }

    const onConfirm = () => {
      this.setState({
        force: true,
      }, () => {
        onCloseCrashMeetingModal()
        this.onSubmitBooking(this.prepareParams() ,isEditBooking)
      })
    }

    return (
      <CrashMeetingModal
        isVisible={isOpenCrashMeetingModal}
        language={language}
        colorTheme={colorTheme}
        onClose={onCloseCrashMeetingModal}
        onChangeDates={onChangeDates}
        onConfirm={onConfirm}
      />
    )
  }

  editModal = () => {
    const { isOpenEditModal } = this.state
    const { language, updateBooking, settingReducer } = this.props
    const { colorTheme } = settingReducer.settingTheme

    return (
      <EditModal
        isVisible={isOpenEditModal}
        language={language}
        colorTheme={colorTheme}
        onClose={() => this.setState({ isOpenEditModal: false })}
        onSave={() => {
          this.setState({ isOpenEditModal: false })
          updateBooking(this.prepareParams())
        }}
      />
    )
  }

  editRepeatModal = () => {
    const {
      isOpenEditRepeatModal,
      selectedKeyRepeatOption,
      recurrence,
      previousRecurrence,
    } = this.state
    const { language, updateBooking, settingReducer } = this.props

    const { colorTheme } = settingReducer.settingTheme
    const previousRecurrenceString = JSON.stringify(previousRecurrence)
    const currentRecurrenceString = JSON.stringify(recurrence)
    const isSameRecurrence = previousRecurrenceString === currentRecurrenceString

    const onSelectedRepeatOption = (key) => {
      this.setState({ selectedKeyRepeatOption: key })
    }

    const onCloseEditRepeatModal = () => {
      this.setState({ isOpenEditRepeatModal: false })
    }

    const onUpdateBooking = (key, isSameRecurrence) => {
      const isRecurrenceUpdate = !isSameRecurrence || (key === REPEAT_OPTION_STATUS.THIS_AND_FOLLOW_SCHEDULE)

      this.setState({ isOpenEditRepeatModal: false })
      updateBooking(this.prepareParams(isRecurrenceUpdate))
    }

    return (
      <EditRepeatModal
        isVisible={isOpenEditRepeatModal}
        isRadio={isSameRecurrence}
        selectedKey={selectedKeyRepeatOption}
        language={language}
        colorTheme={colorTheme}
        onClose={onCloseEditRepeatModal}
        onSelected={onSelectedRepeatOption}
        onSave={() => onUpdateBooking(selectedKeyRepeatOption, isSameRecurrence)}
      />
    )
  }

  async showCateringModal () {
    const { selectedRoom, itemCatering } = this.state

    if (selectedRoom) {
      if (!itemCatering) {
        const callback = () => this.setState({ isShowCateringModal: true })
        await this.service.getlistOrder(MODAL_NAME.CATERING, callback)
        this.setState({ isShowCateringModal: true })
      } else {
        this.setState({
          isShowCateringModal: true
        })
      }
    } else {
      this.displayError(CREATE_BOOKING.SELECT_CATERING_WARNING[this.props.language])
    }

    ReactGA.event({
      category: "Create Booking",
      action: "Add Catering",
    })
  }

  displayError = (description) => {
    const { openModalStatus } = this.props
    openModalStatus({
      status: false,
      description,
      data: null,
      code: null,
    })
  }

  hideCateringModal () {
    this.setState({
      isShowCateringModal: false,
      isShowEquipmentModal: false
    })
  }

  service = {
    getlistOrder: async (modalName, func = () => { }, itemName) => {
      this.setState({ isLoading: true })

      const { selectedCompany, selectedRoom } = this.state
      const companyId = selectedCompany ? selectedCompany.id : this.props.dataUser.companyId
      let cateringTypes = [0, 1, 2, 3]
      const params = {
        companyId,
        type: cateringTypes,
        ordering: 'itemName ASC',
      }

      switch (modalName) {
        case MODAL_NAME.CATERING:
          cateringTypes = [0, 1, 3]
          params.type = cateringTypes
          break
        case MODAL_NAME.EQUIPMENT:
          cateringTypes = [2, 3]
          params.type = cateringTypes
          break
        default:
          params.type = [3]
          params.parentId = selectedRoom.id
          params.status = [0, 1, 2, 3]
      }

      if (itemName) {
        params.itemName = itemName
        params.status = [0, 1, 2, 3]
        params.type = [3]
        params.parentId = selectedRoom.id
      }

      const result = await apiService.get('rest/v1/getlist_catering2', params)
      this.setState({ isLoading: false })

      if (result.status) {
        const itemList = catagorizeItem(result.data.list)

        switch (modalName) {
          case MODAL_NAME.CATERING:
            this.setState({
              itemCatering: {
                0: itemList[0],
                1: itemList[1],
              },
            })
            break
          case MODAL_NAME.EQUIPMENT:
            this.setState({
              itemEquipment: {
                0: itemList[2],
              },
            })
            break

          default:
            break
        }

        return
      }

      this.props.openModalStatus(result)
    },
  }

  async showEquipmentModal () {
    const { selectedRoom, itemEquipment } = this.state

    if (selectedRoom) {
      if (!itemEquipment) {
        const callback = () => this.setState({ isShowEquipmentModal: true })
        await this.service.getlistOrder(MODAL_NAME.EQUIPMENT, callback)
        this.setState({ isShowEquipmentModal: true })
      } else {
        this.setState({
          isShowEquipmentModal: true
        })
      }
    } else {
      this.displayError(CREATE_BOOKING.SELECT_CATERING_WARNING[this.props.language])
    }
    ReactGA.event({
      category: "Create Booking",
      action: "Add Equipment",
    })
  }

  showDatePicker () {
    this.setState({
      isShowDatePicker: true
    })
  }

  hideDatePicker () {
    this.setState({
      isShowDatePicker: false
    })
  }

  onSelectGuest = (item) => {
    const { selectGuestList, guest } = this.state

    this.setState({
      selectGuestList: [
        ...selectGuestList,
        {...item},
      ],
      guest: [
        ...guest,
        {...item},
      ]
    })
  }

  handleSetStateGuestList = (item) => {
    this.setState({
      selectGuestList: [
        ...item,
      ]
    })
  }

  getBookingList (param, func) {
    return apiService.get('rest/v2/getlist_booking', { ...param, showPrivateSubject: true }).then((res) => {
      if (res.status) {
        const bookingListRoom = res.data.list
        const id = this.state.id
        let index = -1
        for (const booking of bookingListRoom) {
          if (booking.bookingId === id) break
          index = index + 1
        }
        if (index >= 0 && index < bookingListRoom.length - 1) {
          bookingListRoom.splice(index, 1)
        }
        this.setState({
          bookingList: bookingListRoom
        })
        func()
      } else if (!res.status) {
        this.props.openModalStatus(res)
      } else {
        console.log('ERROR ACTION getListAllBooking2', res)
      }
    })
  }

  generateParams(selectedDate, selectedRoom) {
    const startDatetime = moment(selectedDate).format('YYYY-MM-DD 00:00:00')
    const endDatetime = moment(selectedDate).format('YYYY-MM-DD 23:59:59')
  
    return {
      startDatetime,
      endDatetime,
      sorts: JSON.stringify([
        { type: 'ASC', column: 'startDatetime' },
        { type: 'DESC', column: 'endDatetime' },
      ]),
      status: '[0,1,2]',
      ...(selectedRoom && selectedRoom.id && { roomId: selectedRoom.id }),
    }
  }

  handleError(message, language) {
    this.displayError(message[language])
  }

  showStartTimePicker(selectedDate) {
    const { selectedRoom } = this.state

    if (selectedDate) {
      const params = this.generateParams(selectedDate, selectedRoom)
      this.getBookingList(params, () => this.setState({ isShowStartTimePicker: true }))
    } else {
      this.handleError.call(this, CREATE_BOOKING.SELECT_START_TIME_PICKER_WARNING, this.props.language)
    }
  }

  hideTimePicker () {
    this.setState({
      isShowStartTimePicker: false,
      isShowEndTimePicker: false
    })
  }

  showEndTimePicker(selectedDate, selectedStartTime) {
    const { selectedRoom } = this.state
  
    if (selectedDate && selectedStartTime) {
      const params = this.generateParams(selectedDate, selectedRoom)
      this.getBookingList(params, () => this.setState({ isShowEndTimePicker: true }))
    } else {
      this.handleError.call(this, CREATE_BOOKING.SELECT_END_TIME_PICKER_WARNING, this.props.language)
    }
  }

  onClickSelectedStartTime (isStatus) {
    if (isStatus !== 2) {
      return defaultFunction
    } else {
      this.showStartTimePicker(this.state.selectedDate)
    }
  }

  onClickSelectedEndTime (isStatus) {
    if (isStatus !== 2) {
      return defaultFunction
    } else {
      this.showEndTimePicker(this.state.selectedDate, this.state.selectedStartTime)
    }
  }

  toggleTimeline(value = false) {
    const { isShowRoomTimeline, selectedDate, selectedRoom } = this.state

    if (!selectedRoom) {
      this.handleError.call(this, CREATE_BOOKING.SELECT_CATERING_WARNING, this.props.language)
    }

    if ((value || !isShowRoomTimeline) && selectedRoom) {
      const params = this.generateParams(selectedDate, selectedRoom)
      this.getBookingList(params, () => this.setState({ isShowRoomTimeline: true }))
    } else {
      this.setState({ isShowRoomTimeline: false })
    }
  }

  _selectDate (selectedDate, select) {
    if (!select) {
      const minuteStep = this.state && this.state.selectedRoom ? this.state.minuteStep : this.props.minuteStep
      let now = new Date()
      let minute = getNearestMinute(now.getMinutes(), minuteStep, 1)
      let hour = now.getHours()

      if (minute >= 60) {
        minute = 0
        hour += 1

        if (hour >= 24) {
          now = null
        }
      }

      let endDate = null

      if (now != null) {
        now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(),
          selectedDate.getDate(), hour, minute)
        endDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(),
          selectedDate.getDate(), hour + 1, minute)

        if (endDate.getDate() !== selectedDate.getDate()) {
          endDate = new Date(endDate.getFullYear(), endDate.getMonth(),
            endDate.getDate(), 0, -minuteStep)
        }

        if (endDate.valueOf() === now.valueOf()) {
          endDate = null
        }
      } else {
        endDate = null
      }

      return {
        selectedDate,
        selectedStartTime: now,
        selectedEndTime: endDate,
        isShowDatePicker: false,
      }
    } else {
      return {
        selectedDate,
        isShowDatePicker: false,
      }
    }
  }

  selectDate (selectedDate) {
    this.setState(this._selectDate(selectedDate, true), () => {
      if (this.state.isShowRoomTimeline) {
        this.toggleTimeline(true)
      }
    })
  }

  selectStartTime (selectedStartTime) {
    const minuteStep = this.state.selectedRoom ? this.state.minuteStep : this.props.minuteStep
    let endDate = new Date(selectedStartTime.getFullYear(), selectedStartTime.getMonth(), selectedStartTime.getDate(), selectedStartTime.getHours() + 1, selectedStartTime.getMinutes())
    if (endDate.getDate() !== selectedStartTime.getDate()) {
      endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, -minuteStep)
    }
    if (endDate.valueOf() === selectedStartTime.valueOf()) endDate = null
    this.setState({
      isShowStartTimePicker: false,
      selectedStartTime: selectedStartTime,
      selectedEndTime: endDate
    })
  }

  selectEndTime (selectedEndTime) {
    this.setState({
      isShowEndTimePicker: false,
      selectedEndTime: selectedEndTime
    })
  }

  selectNotification (item, index) {
    this.setState({
      notification: item,
      notificationTime: NOTIFICATION_TIME_LIST[index]
    })
  }

  toggleIsPrivate () {
    this.setState({
      isPrivate: !this.state.isPrivate
    })
  }

  toggleIsOnlineMeeting() {
    this.setState(
      prevState => ({
        isOnlineMeeting: !prevState.isOnlineMeeting
      }),
      () => {
        this.setState(prevState => {
          if (!this.state.isOnlineMeeting) {
            this.previousMeetingLinkType = prevState.meetingLinkType;
            return {
              meetingLinkType: MEETING_LINK_TYPE.NONE
            };
          } else {
            return {
              meetingLinkType: this.previousMeetingLinkType || MEETING_LINK_TYPE.AUTO
            };
          }
        });
      }
    );
  }

  handleDetailChange (event, maxCharacter) {
    event.preventDefault()
    this.setState({
      bookingDetail: event.target.value.slice(0, maxCharacter)
    })
  }

  handleProjectNameChange (event, maxCharacter) {
    event.preventDefault()
    this.setState({
      projectName: event.target.value.slice(0, maxCharacter)
    })
  }

  handleMoveTimeline (data) {
    const { canEdit, status, id } = this.state
    if (canEdit && status === 2) {
      const timestampEnd = data.endDatetime.valueOf()
      const timestamp = data.startDatetime.valueOf()
      if (this.state.bookingList.some((booking) => {
        if (booking.id !== id) {
          if (timestampEnd >= booking.startDatetime.valueOf() && timestamp < booking.endDatetime.valueOf()) {
            return true
          }
        }
        return false
      })) {
        return this.setState({})
      } else {
        const selectedDate = new Date(Math.floor((data.startDatetime.valueOf()) / oneDayTimeStamp) * oneDayTimeStamp)
        const selectedEndTime = new Date(data.endDatetime.valueOf() + timezoneOffset)
        const selectedStartTime = new Date(data.startDatetime.valueOf() + timezoneOffset)
        this.setState({
          selectedDate: selectedDate,
          selectedEndTime: selectedEndTime,
          selectedStartTime: selectedStartTime
        })
      }
    }
  }

  handleClickTimeline (timestamp) {
    const { canEdit, status } = this.state
    if (canEdit && status === 2) {
      let endDatetimeOffset = oneHourTimeStamp
      if (this.state.bookingList.some((booking) => {
        const diffTime = booking.startDatetime.valueOf() - timestamp
        if (diffTime < oneHourTimeStamp && diffTime > 0) endDatetimeOffset = booking.startDatetime.valueOf() - timestamp
        if (booking.startDatetime.valueOf() === timestamp) {
          return true
        } else if (timestamp > booking.startDatetime.valueOf() && timestamp < booking.endDatetime.valueOf()) {
          return true
        }
        return false
      })) return null
      const selectedDate = new Date(timestamp + timezoneOffset)
      const minuteStep = this.state.selectedRoom ? this.state.minuteStep : this.props.minuteStep
      const timestampStep = minuteStep * 60 * 1000
      if (selectedDate.getDate() !== this.state.selectedDate.getDate() ||
        (selectedDate.getHours() === 23 && selectedDate.getMinutes() >= 60 - minuteStep)) return null
      let selectedEndTime = this.initDatetime(new Date(timestamp + endDatetimeOffset + timezoneOffset))

      if (selectedEndTime.getDate() !== selectedDate.getDate()) {
        const todayTimestamp = (Math.ceil((selectedEndTime.valueOf()) / oneDayTimeStamp) * oneDayTimeStamp) - timestampStep
        selectedEndTime = this.initDatetime(new Date(todayTimestamp + timezoneOffset))
      }
      this.setState({
        selectedStartTime: selectedDate,
        selectedEndTime: selectedEndTime
      })
    }
  }

  handleMeetingLinkChange = (event) => {
    event.preventDefault()

    this.setState({
      meetingLink: event.target.value,
    })
  }

  resetState () {
    const { clearRecurrence } = this.state
    const { language } = this.props

    const resetState = cloneDeep(this.initialState)

    resetState.previousRecurrence = {...clearRecurrence}
    resetState.recurrenceText = this.getResultText(clearRecurrence, language)

    resetState.selectGuestList = this.state.guestCurrent
      ? [...this.state.guestCurrent]
      : []

    this.setState(resetState)

    this.trackingResetButton()
  }

  handleUpdateBooking (params) {
    const { updateBooking } = this.props
    const { recurrence } = params

    if (!params.force) {
      recurrence
        ? this.setState({ isOpenEditRepeatModal: true })
        : this.setState({ isOpenEditModal: true })
    } else {
      updateBooking(this.prepareParams(params.isRecurrenceUpdate))
    }
  }

  onSubmitBooking (params, isEditing) {
    const { createBooking } = this.props
    this.setState({ isDisabledSaveButton: true })
    this.isSaving = true

    if (isEditing) {
      this.handleUpdateBooking(params)
    } else {
      createBooking(params, this.trackingSaveButton)
    }

    this.setState({ isDisabledSaveButton: false })
  }

  onChangeTextIssue = (e) => {
    this.setState({
      textIssue: e.target.value,
      selecteIssue: null
    }, () => {
      const {
        textIssue
      } = this.state
      this.service.getlistOrder(MODAL_NAME.FACILITY, () => { }, textIssue)
    })
  }

  clearSelectIssue = () => {
    this.setState({
      textIssue: '',
      selecteIssue: null
    })
  }

  selecteIssue = (selecteIssue) => {
    this.setState({
      selecteIssue,
      textIssue: selecteIssue.name,
    })
  }

  onChangeTextIssueDetail = (e) => {
    this.setState({
      detailIssue: e.target.value
    })
  }

  getListHoliday = ({ year, month, countDay }) => {
    const {
      getListHoliday,
      dataUser
    } = this.props
    const startDateTime = new Date(year, month, 1)
    const endDateTime = new Date(year, month, countDay)
    const param = {
      'startDatetime': moment(startDateTime).format('YYYY-MM-DD'),
      'endDatetime': moment(endDateTime).format('YYYY-MM-DD'),
      'companyId': dataUser.companyId,
      limit: 35
    }
    getListHoliday(param)
  }

  goToMainPage = () => {
    this.setState({
      showModalEndMeeting: false
    },
      this.goBack()
    )
  }

  convertTimeStringToDate (timeString, date = new Date()) {
    const dateString = [date.getFullYear(), (date.getMonth() + 1).toString().padStart(2, 0), date.getDate().toString().padStart(2, 0)].join('/')
    const output = new Date([dateString, timeString].join(' '))
    if (isNaN(output.valueOf())) return null
    return output
  }

  trackingSaveButton () {
    ReactGA.event({
      category: "Create Booking",
      action: "save_button",
    })
  }

  trackingResetButton () {
    ReactGA.event({
      category: "Create Booking",
      action: "reset_button",
    })
  }

  trackingEndMeetingButton () {
    ReactGA.event({
      category: "Create Booking",
      action: "endmeeting_button",
    })
  }

  updateGuestList = (guest) => {
    this.setState({ guest })
  }

  modal = {
    openModalInformation: () => {
      const { modalAction } = this.props
      modalAction.openModalInformation()
    },
    closeModalInformation: () => {
      const { modalAction } = this.props
      modalAction.closeModalInformation()
    },
  }

  removeResourceItem = (type, itemInfo) => {
    const isCatering = type === 'catering'
    const orderStateKey = isCatering ? 'orderCatering' : 'orderEquipment'
    const itemStateKey = isCatering ? 'itemCatering' : 'itemEquipment'
    const countStateKey = isCatering ? 'countCatering' : 'countEquipment'

    if (itemInfo.isOrder) {
      const newOrderList = JSON.parse(JSON.stringify(this.state[orderStateKey]))
      const itemToUpdate = newOrderList[itemInfo.orderIndex] ? newOrderList[itemInfo.orderIndex].items.find(i => i.itemId === itemInfo.itemId) : null
      if (itemToUpdate) itemToUpdate.amount = 0
      
      this.setState({
        [orderStateKey]: newOrderList,
        [countStateKey]: countOrderItems(newOrderList) + countNewItems(this.state[itemStateKey])
      })
    } else {
      const newItemList = JSON.parse(JSON.stringify(this.state[itemStateKey]))
      const itemToUpdate = newItemList[itemInfo.catKey] ? newItemList[itemInfo.catKey].find(i => i.itemId === itemInfo.itemId) : null
      if (itemToUpdate) itemToUpdate.amount = 0
      
      this.setState({
        [itemStateKey]: newItemList,
        [countStateKey]: countOrderItems(this.state[orderStateKey]) + countNewItems(newItemList)
      })
    }
  }

  renderSpaceResourceItems(orderCatering, itemCatering, type, language, isView) {
    let allItems = []

    if (orderCatering && Array.isArray(orderCatering)) {
      orderCatering.forEach((order, orderIndex) => {
        if (order && order.items) {
          order.items.forEach(item => {
            if (item.amount > 0) {
              allItems.push({ ...item, isOrder: true, orderIndex })
            }
          })
        }
      })
    }

    if (itemCatering) {
      Object.keys(itemCatering).forEach(catKey => {
        itemCatering[catKey].forEach(item => {
          if (item.amount > 0) {
            allItems.push({ ...item, isOrder: false, catKey })
          }
        })
      })
    }

    if (allItems.length === 0) {
      return (
        <div style={{ padding: '0 16px', border: `1.5px solid ${isView ? COLOR.GRAY_1 : COLOR.GRAY_5}`, borderRadius: 8, color: COLOR.GRAY_27, background: isView ? COLOR.GRAY_1 : 'transparent', fontSize: 18, height: 48, display: 'flex', alignItems: 'center' }}>
          {CREATE_BOOKING.NO_REQUEST ? CREATE_BOOKING.NO_REQUEST[language] : (language === 'TH' ? 'ไม่มีคำขอ' : 'No request')}
        </div>
      )
    }

    return (
      <div style={{ padding: '4px 16px', border: `1.5px solid ${isView ? COLOR.GRAY_1 : COLOR.GRAY_5}`, borderRadius: 8, background: isView ? COLOR.GRAY_1 : 'transparent', color: isView ? COLOR.GRAY_27 : COLOR.BLACK_6 }}>
        {allItems.map((item, index) => (
          <div key={index} style={{
            padding: '4px 0',
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            minHeight: 32
          }}>
            <span style={{ fontSize: 18, color: isView ? COLOR.GRAY_27 : COLOR.BLACK_6, flex: 1, fontFamily: 'NunitoSans, sans-serif' }}>{item.itemName}</span>
            <div style={{ display: 'flex', alignItems: 'center', width: 110, justifyContent: 'space-between' }}>
              <span style={{ fontSize: 18, color: isView ? COLOR.GRAY_27 : COLOR.BLACK_6, width: 24, textAlign: 'right', fontFamily: 'NunitoSans, sans-serif' }}>{item.amount}</span>
              <span style={{ fontSize: 18, color: isView ? COLOR.GRAY_27 : COLOR.BLACK_6, flex: 1, textAlign: 'center', fontFamily: 'NunitoSans, sans-serif' }}>
                {language === 'EN' ? (item.amount <= 1 ? 'Unit' : 'Units') : CREATE_BOOKING.UNIT[language]}
              </span>
              {!isView && (
                <img
                  src={IMG['ic_close-red.svg']}
                  alt="Close"
                  onClick={() => this.removeResourceItem(type, item)}
                  style={{ 
                    cursor: 'pointer', 
                    width: 24, 
                    height: 24, 
                    padding: 4, 
                    boxSizing: 'border-box',
                    display: 'block',
                    marginTop: 0
                  }}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    )
  }

  render () {
    const props = Object.assign({}, this.props)
    const state = Object.assign({}, this.state)
    const language = props.language
    const validated = this.validateInput()
    let disabledMinute = null
    let disabledHour = null
    let selectedTime = null
    let handleSaveButton = defaultFunction
    let startSelectable = null
    let endSelectable = null
    let startDateTime = null

    let cateringMode = -1
    let menuList = defaultList
    let cateringLabel = ''
    let itemList = {}
    let orderList = defaultList
    let bookingListRoom = []
    if (state.isShowRoomTimeline) {
      const activeBooking = state.bookingList.find((booking) => booking.id === state.id)
      if (activeBooking) {
        activeBooking.isActive = true
        activeBooking.projectName = state.projectName
        activeBooking.startDatetime = new Date(state.selectedStartTime - timezoneOffset)
        activeBooking.endDatetime = new Date(state.selectedEndTime - timezoneOffset)
        bookingListRoom = state.bookingList.slice()
      } else {
        bookingListRoom = state.bookingList.slice().concat([{
          id: state.id,
          projectName: state.projectName,
          startDatetime: new Date(state.selectedStartTime - timezoneOffset),
          endDatetime: new Date(state.selectedEndTime - timezoneOffset),
          owner: state.selectedOwner.username,
          isActive: true,
          status: state.status
        }])
      }
    }

    if (state.isShowStartTimePicker) {
      disabledMinute = convertBooklistToDisabledMinute(state.bookingList, state.minuteStep, state.id)
      if (disabledMinute[23] != null) {
        disabledMinute[23].push(60 - state.minuteStep)
      } else {
        disabledMinute[23] = [60 - state.minuteStep]
      }
      startSelectable = this.getNowMinusStep(state.minuteStep, state.selectedDate, state.startOperatingTime)
      disabledHour = getDisabledHour(disabledMinute, state.minuteStep, startSelectable, state.selectedDate)
      selectedTime = state.selectedStartTime
      handleSaveButton = (event, selectedTime) => this.selectStartTime(selectedTime)
      const endOperatingTime = this.convertTimeStringToDate(state.endOperatingTime, state.selectedDate)
      endSelectable = new Date(endOperatingTime * 1 - (state.minuteStep * 60000))
    } else if (state.isShowEndTimePicker) {
      for (const booking of state.bookingList) {
        if (booking.id === state.id) continue
        const dateTime = new Date(moment(booking.startDatetime).format().replace('Z', ''))
        if (startDateTime === null || dateTime < startDateTime) startDateTime = dateTime
      }
      selectedTime = state.selectedEndTime
      handleSaveButton = (event, selectedTime) => this.selectEndTime(selectedTime)
      startSelectable = this.getNowMinusStep(-state.minuteStep, state.selectedStartTime, state.startOperatingTime)
      const endOperatingTime = this.convertTimeStringToDate(state.endOperatingTime, state.selectedDate)
      endSelectable = startDateTime > endOperatingTime ? startDateTime : endOperatingTime
    } else if (state.isShowCateringModal) {
      menuList = menuCateringList
      cateringLabel = CREATE_BOOKING.SELECT_CATERING
      cateringMode = 1
      itemList = state.itemCatering
      orderList = state.orderCatering
    } else if (state.isShowEquipmentModal) {
      menuList = menuEquipmentList
      cateringLabel = CREATE_BOOKING.SELECT_EQUIPMENT
      cateringMode = 2
      itemList = state.itemEquipment
      orderList = state.orderEquipment
    }
    const { status, isOpenSuggestRoom } = this.state

    let {
      params,
      listHoliday,
      settingReducer,
      companyTokenType,
    } = this.props

    const { colorTheme } = settingReducer.settingTheme

    let showPermission = false
    if (
      (state.isEditing && checkPermission(props.permission, ROUTE.CALENDAR.ACTION.UPDATE)) ||
      (!state.isEditing && checkPermission(props.permission, ROUTE.CALENDAR.ACTION.CREATE)) ||
      (!state.isEditing && checkPermission(props.permission, ROUTE.FLOORPLAN.ACTION.CREATE)) ||
      (!state.isEditing && checkPermission(props.permission, ROUTE.FLOORPLAN.ACTION.UPDATE)) ||
      (!state.isEditing && checkPermission(props.permission, ROUTE.MEETING_ROOM.ACTION.CREATE)) ||
      (!state.isEditing && checkPermission(props.permission, ROUTE.MEETING_ROOM.ACTION.UPDATE))) {
      showPermission = true
    }

    const roomStatus = getRoomBookingStatus(state.status)
    const isDisabledRoom = state.lockRoom || !state.canEdit || state.status !== STATUS.NOT_YET_TIME_MEETING
    const statusUsed = 0
    const isUsed = state.status === statusUsed
    const optionsMeetingLinkType = [CREATE_BOOKING.NO_ONLINE_MEETING, CREATE_BOOKING.AUTO_GENERATE_ONLINE_MEETING_LINK, CREATE_BOOKING.ADD_YOUR_LINK]
    const isDisableEdit = state.status !== STATUS.NOT_YET_TIME_MEETING || !state.isEditable
    const isDesk = this.isDeskBooking(state)
    const isDeskFloorPlanOfFloor = Boolean(state.selectedFloor) && state.deskFloorPlan.floorId === state.selectedFloor.id
    const isDeskDropdown = isDeskFloorPlanOfFloor && state.deskFloorPlan.status === 'unavailable'
    const isCheckInRequired = Boolean(state.selectedRoom) && Boolean(state.selectedRoom.checkInRequired ?? state.checkInRequired)
    const isRoomFieldDisabled =isDisabledRoom || !state.isEditable || !state.selectedBuilding || !state.selectedFloor || !state.spaceType

    let textBreadcrumbStart = MENU.MEETING_ROOM[language] || 'Meeting Spaces'
    const isEditingBooking = props.params.bookingId && !isNaN(props.params.bookingId)
    let textBreadcrumbEnd = isEditingBooking ? CREATE_BOOKING.UPDATE_BOOKING[language] : CREATE_BOOKING.CREATE_BOOKING[language]
    const contextDate = (props.query && props.query.date) ? new Date(props.query.date) : (state.selectedDate ? new Date(state.selectedDate) : new Date())

    if (props.location && props.location.search) {
      const searchParams = new URLSearchParams(props.location.search)
      const fromParam = searchParams.get('from')
      
      if (fromParam === 'meetingroom_detail') {
        textBreadcrumbStart = [
          { title: MENU.MEETING_ROOM[language] || 'Meeting Spaces', onClick: () => props.history.push(ROUTE.MEETING_ROOM.LIST) },
          { title: TABLE.ROOM_DETAIL[language], onClick: this.goBack }
        ]
      } else if (fromParam === 'meetingroom_timeline') {
        textBreadcrumbStart = [
          { title: MENU.MEETING_ROOM[language] || 'Meeting Spaces', onClick: () => props.history.push(ROUTE.MEETING_ROOM.LIST) },
          { title: TABLE.TIME_SLOT[language], onClick: this.goBack }
        ]
      } else if (fromParam === 'floorplan_timeline') {
        textBreadcrumbStart = [
          { title: MENU.FLOOR_PLAN[language] || 'Floor Plan', onClick: () => props.history.push(`${ROUTE.FLOORPLAN.LINK}/${contextDate.getFullYear()}/${contextDate.getMonth() + 1}/${contextDate.getDate()}`) },
          { title: TABLE.TIME_SLOT[language], onClick: this.goBack }
        ]
      } else if (fromParam === 'floorplan') {
        textBreadcrumbStart = [
          { title: MENU.FLOOR_PLAN[language] || 'Floor Plan', onClick: () => props.history.push(this.getFloorPlanPath(contextDate)) }
        ]
      } else if (props.location.search.includes('roomId')) {
        textBreadcrumbStart = [
          { title: MENU.FLOOR_PLAN[language] || 'Floor Plan', onClick: () => props.history.push(`${ROUTE.FLOORPLAN.LINK}/${contextDate.getFullYear()}/${contextDate.getMonth() + 1}/${contextDate.getDate()}`) },
          { title: TABLE.TIME_SLOT[language], onClick: this.goBack }
        ]
      } else if (props.location.search.includes('date')) {
        textBreadcrumbStart = [
          { title: MENU.MY_CALENDAR[language] || 'Calendar', onClick: () => props.history.push(`${ROUTE.CALENDAR.LINK}/month/${contextDate.getFullYear()}/${contextDate.getMonth() + 1}/${contextDate.getDate()}`) }
        ]
      }
    }

    return (
      <Style colorTheme={colorTheme}>
        <Topbar
          onClickBackToBeforePage={this.goBack}
          textBreadcrumbStart={textBreadcrumbStart}
          textBreadcrumbEnd={textBreadcrumbEnd}
          textCenter={getLocaleDateStringFull(contextDate, language)}
        />

        <section className='booking-container-wrapper flex-horizontal no-margin no-padding stretch'>
          {(state.isLoading || props.loader) && <Loader colorTheme={colorTheme} />}

          {(props.modalStatus) &&
            <ModalStatus
              language={language}
              code={props.modalStatus.code}
              action={props.modalStatus.status
                ? `${state.isEditing ? CREATE_DEFAULT.EDIT[language] : CREATE_DEFAULT.CREATE[language]}${MODAL_STATUS.COMPLELTE[language]}`
                : MODAL_STATUS.WARNING[language]}
              text={props.modalStatus.status
                ? props.modalStatus.textResponse
                : props.modalStatus.description}
              status={props.modalStatus.status}
              onClick={props.modalStatus.status || props.modalStatus.doGoBack ? () => {
                props.closeModalStatus()
                this.goBack()
              } : props.closeModalStatus}
              colorTheme={colorTheme}
            />
          }

          {props.modalReducer.isOpenModalInformation && (
            <ModalInformation
              headerName={MEETING_CANNOT_BE_EDITED.HEADER[language]}
              colorTheme={colorTheme}
              descriptionName={companyTokenType === COMPANY_TOKEN_TYPE.GOOGLE ? MEETING_CANNOT_BE_EDITED.DESCRIPTION.GOOGLE[language] : MEETING_CANNOT_BE_EDITED.DESCRIPTION.MICROSOFT[language]}
              buttonName={MODAL_CONFIRM.CLOSE[language]}
              onClick={() => this.modal.closeModalInformation()}
            />
          )}

          {state.showModalEndMeeting &&
            <ModalStatus
              language={language}
              action={MODAL_STATUS.SUCCESS[language]}
              text={END_MEETING.COMPLETED[language]}
              status={state.showModalEndMeeting}
              onClick={this.goToMainPage}
              colorTheme={colorTheme}
            />
          }

          {!state.isHiding && showPermission
            && (
              <section className='booking-container'>
                {(state.isShowDatePicker) &&
                  <DatePicker
                    isShowing={state.isShowDatePicker}
                    selectDate={state.selectedDate}
                    handleCloseButton={() => this.hideDatePicker()}
                    handleSaveButton={(event, selectedDate) => this.selectDate(selectedDate)}
                    startSelectable={new Date()}
                    language={language}
                    getHolidays={this.getListHoliday}
                    listHoliday={listHoliday}
                    colorTheme={colorTheme}
                  />
                }
                {(state.isShowStartTimePicker || state.isShowEndTimePicker) &&
                  <TimePicker
                    selectTime={selectedTime}
                    selectedDate={state.selectedDate}
                    handleCloseButton={() => this.hideTimePicker()}
                    handleSaveButton={handleSaveButton}
                    startSelectable={startSelectable}
                    endSelectable={endSelectable}
                    minuteStep={state.minuteStep}
                    disabledMinute={disabledMinute}
                    disabledHour={disabledHour}
                    language={language}
                    isShowStartTimePicker={Boolean(state.isShowStartTimePicker)}
                    startOperatingTime={state.startOperatingTime}
                    endOperatingTime={state.endOperatingTime}
                    colorTheme={colorTheme}
                  />
                }
                {isDesk && state.isShowDeskFloorPlanModal && isDeskFloorPlanOfFloor && state.deskFloorPlan.status === 'ready' && (
                  <DeskFloorPlanModal
                    isVisible
                    language={language}
                    colorTheme={colorTheme}
                    themeConfig={settingReducer.settingTheme.themeConfig}
                    floorId={state.deskFloorPlan.floorId}
                    floorPlan={state.deskFloorPlan.data}
                    initialDate={state.selectedDate}
                    initialStartTime={state.selectedStartTime}
                    selectedDeskId={state.selectedRoom ? state.selectedRoom.id : null}
                    currentDeskId={state.isEditing && this.initialState.selectedRoom ? this.initialState.selectedRoom.id : null}
                    minuteStep={state.minuteStep}
                    startOperatingTime={state.startOperatingTime}
                    endOperatingTime={state.endOperatingTime}
                    getHolidays={this.getListHoliday}
                    listHoliday={listHoliday}
                    onClose={this.closeDeskFloorPlanModal}
                    onConfirm={this.selectDeskFromFloorPlan}
                  />
                )}
                {(state.isShowCateringModal || state.isShowEquipmentModal) &&
                  <CateringModal
                    btnList={btnList}
                    btnListOrder={btnListOrder}
                    menuList={(state.status === STATUS.END_MEETING) ? [menuList[menuList.length - 1]] : menuList}
                    // menuList={(state.status === 0 || !state.canEdit) ? [menuList[menuList.length - 1]] : menuList}
                    handleBackBtn={() => this.hideCateringModal()}
                    handleCancelBtn={(_orderList) => this.handleCancelCatering(cateringMode, _orderList)}
                    handleSaveBtn={(_orderList) => this.handleSaveCatering(cateringMode, _orderList)}
                    handleDoneBtn={(_itemList) => this.handleDoneCatering(cateringMode, _itemList)}
                    labelHeader={cateringLabel}
                    orderList={orderList}
                    itemList={itemList}
                    status={status}
                    colorTheme={colorTheme}
                  />
                }
                <section className='booking-content'>
                  <section className='booking-header'>
                    <label className='booking-title'>
                      {state.isEditing
                        ? roomStatus.isWaiting()
                          ? CREATE_BOOKING.UPDATE_BOOKING[language]
                          : CREATE_BOOKING.DETAIL_BOOKING[language]
                        : CREATE_BOOKING.CREATE_BOOKING[language]
                      }
                    </label>
                  </section>
                  <section className={`content-container ${state.guestText ? 'min-height-700' : ''}`}>
                    {/* Move to bottom duration after customer aggree */}
                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.COMPANY[language]}:</label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='flex-vertical margin-btm-5'>
                          <InputField
                            disabled={true}
                            value={state.selectedCompany ? state.selectedCompany.name : (props.dataUser.companyName || '')}
                            className='field-input readonly'
                          />
                        </div>
                      </section>
                    </section>

                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.BUILDING[language]}:<span className='required-mark'>*</span></label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <SearchAndSelect
                          typeIcon='autosuggest'
                          icon='ic_expand-more.svg'
                          placeholder={CREATE_BOOKING.SELECT_BUILDING[language]}
                          classInput='input-data'
                          className={'div-search margin-btm-5'.concat(state.isError && !state.selectedBuilding ? ' error' : '')}
                          keyword={state.buildingText}
                          onChangeSearch={(event) => this.searchBuilding(event.target.value)}
                          empty={state.selectedBuilding}
                          list={state.buildingList}
                          onClickList={(building) => this.selectBuilding(building)}
                          colorTheme={colorTheme}
                          clearSearch={() => {
                            this.deselectBuilding()
                            this.searchBuilding('')
                          }}
                          disabled={isDisableEdit || state.lockRoom}
                          onFocus={() => {
                            this.setState({isOpenSuggestBuilding: true})
                            this.searchBuilding('')
                          }}
                          onBlur={() => {
                            this.setState({isOpenSuggestBuilding: false})
                            if (!this.state.selectedBuilding) {
                              this.setState({ buildingText: '' })
                            }
                          }}
                          isOpenDropdown={state.isOpenSuggestBuilding && !state.isLoading}
                        />
                      </section>
                    </section>

                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.FLOOR[language]}:<span className='required-mark'>*</span></label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <SearchAndSelect
                          typeIcon='autosuggest'
                          icon='ic_expand-more.svg'
                          placeholder={CREATE_BOOKING.SELECT_FLOOR[language]}
                          classInput='input-data'
                          className={'div-search margin-btm-5'.concat(state.isError && !state.selectedFloor ? ' error' : '')}
                          keyword={state.floorText}
                          onChangeSearch={(event) => this.searchFloor(event.target.value)}
                          empty={state.selectedFloor}
                          list={state.floorList}
                          onClickList={(floor) => this.selectFloor(floor)}
                          colorTheme={colorTheme}
                          clearSearch={() => {
                            this.deselectFloor()
                            this.searchFloor('')
                          }}
                          disabled={isDisableEdit || !state.selectedBuilding || state.lockRoom}
                          onFocus={() => {
                            this.setState({isOpenSuggestFloor: true})
                            this.searchFloor('')
                          }}
                          onBlur={() => {
                            this.setState({isOpenSuggestFloor: false})
                            if (!this.state.selectedFloor) {
                              this.setState({ floorText: '' })
                            }
                          }}
                          isOpenDropdown={state.isOpenSuggestFloor && !state.isLoading}
                        />
                      </section>
                    </section>

                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.SPACE_TYPE[language]}:</label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='flex-vertical margin-btm-5'>
                          <SpaceTypeSelect
                            classInput='input-data'
                            className={'div-search margin-btm-5'}
                            value={state.spaceType}
                            onChange={this.handleSpaceTypeChange}
                            language={language}
                            colorTheme={colorTheme}
                            disabled={isDisableEdit || state.lockRoom}
                          />
                        </div>
                      </section>
                    </section>

                    {isDesk && !isDeskDropdown ? (
                      <section className='content'>
                        <label className='content-header'>{(state.selectedRoom ? DESK_FLOOR_PLAN.DESK_NAME : DESK_FLOOR_PLAN.DESK_SPACE)[language]}:<span className='required-mark'>*</span></label>
                        <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                          <button
                            type='button'
                            className={'div-search-select desk-space-field margin-btm-5'.concat(state.isError && !state.selectedRoom ? ' error' : '')}
                            disabled={isRoomFieldDisabled}
                            onClick={this.openDeskFloorPlanModal}
                          >
                            <span className={`desk-space-value${state.selectedRoom ? '' : ' placeholder'}`}>
                              {state.selectedRoom ? state.selectedRoom.name : DESK_FLOOR_PLAN.SELECT[language]}
                            </span>
                            {isCheckInRequired && <span className='desk-space-checkin' aria-label='require check-in' />}
                            <img className='desk-space-arrow' src={IMG['ic_expand-more.svg']} alt='' />
                          </button>
                        </section>
                      </section>
                    ) : (
                      <section className='content'>
                        <label className='content-header'>{CREATE_BOOKING.MEETING_SPACE[language]}:<span className='required-mark'>*</span></label>
                        <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                          <SearchAndSelect
                            typeIcon='autosuggest'
                            icon='ic_expand-more.svg'
                            placeholder={CREATE_DEFAULT.SELECT_ROOM[language]}
                            classInput='input-data'
                            className={'div-search margin-btm-5'.concat(state.isError && !state.selectedRoom ? ' error' : '')}
                            keyword={state.roomText}
                            onChangeSearch={(event) => this.searchRoom(event.target.value)}
                            empty={state.selectedRoom}
                            list={state.roomList}
                            onClickList={(room) => this.selectRoom(room)}
                            colorTheme={colorTheme}
                            clearSearch={() => {
                              this.deselectRoom()
                              this.searchRoom('')
                            }}
                            disabled={isRoomFieldDisabled}
                            onFocus={() => {
                              this.setState({isOpenSuggestRoom: true})
                              this.searchRoom('')
                            }}
                            onBlur={() => {
                              this.setState({isOpenSuggestRoom: false})
                              if (!this.state.selectedRoom) {
                                this.setState({ roomText: '' })
                              }
                            }}
                            isOpenDropdown={state.isOpenSuggestRoom && !state.isLoading}
                            language={language}
                            isRoom={true}
                            showCheckInIcon={isCheckInRequired}
                          />
                        </section>
                      </section>
                    )}

                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.ZONE[language]}:</label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='flex-vertical margin-btm-5'>
                          <InputField
                            disabled={true}
                            value={state.selectedRoom ? (state.selectedRoom.zoneName || CREATE_BOOKING.NO_ZONE[language]) : '-'}
                            className='field-input readonly'
                          />
                        </div>
                      </section>
                    </section>

                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.OWNER[language]}:</label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='flex-vertical margin-btm-5'>
                          <InputField
                            disabled={true}
                            value={state.selectedOwner ? state.selectedOwner.name : props.dataUser.name}
                            className='field-input readonly'
                          />
                        </div>
                      </section>
                    </section>

                    {!isDesk && (
                    <section className='content'>
                      <div className='content-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <label style={{ margin: 0, lineHeight: 1 }}>{CREATE_BOOKING.MEETING_SUBJECT[language]}:<span className='required-mark'>*</span></label>
                        <Checkbox2
                          label={CREATE_BOOKING.IS_PRIVATE[language]}
                          className='project-name-checkbox text-button'
                          handleClick={() => this.toggleIsPrivate()}
                          value={Boolean(state.isPrivate)}
                          disabled={state.status !== STATUS.NOT_YET_TIME_MEETING}
                          colorTheme={colorTheme}
                        />
                      </div>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='flex-vertical margin-btm-5'>
                          <InputField
                            disabled={isDisableEdit}
                            value={state.projectName}
                            maxLength={60}
                            placeholder={CREATE_BOOKING.MEETING_TOPIC_PLACEHOLDER[language]}
                            onChange={(event) => this.handleProjectNameChange(event, 60)}
                            className={'field-input'.concat(state.isError && !state.projectName ? ' error' : '')}
                          />
                        </div>
                      </section>
                    </section>
                    )}

                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.INFO[language]}:</label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='flex-vertical margin-btm-5'>
                          <TextArea
                            className='text-area'
                            value={state.bookingDetail}
                            placeholder={CREATE_BOOKING.MEETING_DETAIL_PLACEHOLDER[language]}
                            onChange={(event) => this.handleDetailChange(event, 1500)}
                            disabled={isDisableEdit}
                            handleEditModal={this.modal.openModalInformation}
                            isEditable={state.isEditable}
                          />
                          <label className='text-character'>
                            {CREATE_BOOKING.CHARACTER[language](
                              state.bookingDetail.length,
                              1500,
                            )}
                          </label>
                        </div>
                      </section>
                    </section>

                    {!isDesk && (
                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.GUEST[language]}:</label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='search-field margin-btm-5 position-relative line-height-20'>
                          <GuestMultiSelect 
                            list={state.selectedOwner.username ? state.userList.filter(res => res.username !== state.selectedOwner.username) : state.userList}
                            guest={this.state.guest}
                            selectGuestList={this.state.selectGuestList}
                            onSelectGuest={this.onSelectGuest}
                            listEdit={params.bookingId && state.guestCurrent ? state.guestCurrent : []}
                            onFocus={() => this.searchGuest('')}
                            value={state.guestText}
                            searchedKeyword={state.guestSearchKeyword}
                            isSearching={state.isSearchingGuest}
                            onChange={(event) => this.searchGuest(event.target.value)}
                            updateGuestList={this.updateGuestList}
                            disabled={state.status === STATUS.END_MEETING || !state.isEditable}
                            handleSetStateGuestList={this.handleSetStateGuestList}
                            isError={state.isError}
                            language={language}
                            colorTheme={colorTheme}
                          />
                        </div>
                      </section>
                    </section>
                    )}

                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.DATE ? CREATE_BOOKING.DATE[language] : 'Date'}:</label>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='flex-vertical margin-btm-5'>
                          <button
                            disabled={isDisableEdit}
                            className={'field-input date-input'.concat(state.isError && !state.selectedDate ? ' error' : '')}
                            onClick={state.status !== STATUS.NOT_YET_TIME_MEETING ? defaultFunction : () => this.showDatePicker()}
                            style={{pointerEvents: isDisableEdit ? 'none' : 'auto', width: '100%', maxWidth: '100%'}}
                          >
                            {state.selectedDate
                              ? getLocaleDateString(state.selectedDate, language)
                              : null
                            }
                          </button>
                        </div>
                      </section>
                    </section>

                    <section className='content'>
                      <div className='content-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <label style={{ margin: 0, lineHeight: 1 }}>
                          {CREATE_BOOKING.Duration[language]}: 
                          {state.selectedStartTime && state.selectedEndTime && (
                            <span style={{fontWeight: 'normal', color: '`${COLOR.GRAY_27}`', marginLeft: '8px'}}>
                              {Math.round((state.selectedEndTime.getTime() - state.selectedStartTime.getTime()) / 360000) / 10} {Math.round((state.selectedEndTime.getTime() - state.selectedStartTime.getTime()) / 360000) / 10 <= 1 ? CREATE_BOOKING.HOUR[language] : CREATE_BOOKING.HOURS[language]}
                            </span>
                          )}
                        </label>
                        <label className='text-button' style={{ margin: 0, color: colorTheme || '#D8A253', cursor: 'pointer', textDecoration: 'underline', fontSize: '16px', fontWeight: 400, fontFamily: 'NunitoSans, sans-serif' }} onClick={(state.status !== STATUS.NOT_YET_TIME_MEETING) ? defaultFunction : (event) => this.toggleTimeline()}>
                          {CREATE_BOOKING.SHOW_TIMELINE[language]}
                        </label>
                      </div>
                      <section className='content-body' onClick={() => state.isEditable ? null : this.modal.openModalInformation()}>
                        <div className='flex-horizontal time-input-block margin-btm-5' style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                          <button
                            disabled={isDisableEdit}
                            className={'field-input date-input'.concat(state.isError && !state.selectedStartTime ? ' error' : '')}
                            onClick={() => this.onClickSelectedStartTime(state.status)}
                            style={{pointerEvents: isDisableEdit ? 'none' : 'auto', flex: 1, maxWidth: 'calc(50% - 20px)', textAlign: 'center'}}
                          >
                            {state.selectedStartTime ? state.selectedStartTime.toTimeString().split(':', 2).join(' : ') : ' '}
                          </button>
                          <span className='margin-12' style={{ width: '40px', textAlign: 'center' }}>{CREATE_BOOKING.TO[language]}</span>
                          <button
                            disabled={isDisableEdit}
                            className={'field-input date-input'.concat(state.isError && !state.selectedEndTime ? ' error' : '')}
                            onClick={() => this.onClickSelectedEndTime(state.status)}
                            style={{pointerEvents: isDisableEdit ? 'none' : 'auto', flex: 1, maxWidth: 'calc(50% - 20px)', textAlign: 'center'}}
                          >
                            {state.selectedEndTime ? state.selectedEndTime.toTimeString().split(':', 2).join(' : ') : ' '}
                          </button>
                        </div>
                      </section>
                    </section>

                  {!isDesk && (
                  <section className='content'>
                    <label className='content-header'>{CREATE_BOOKING.MEETING_LINK[language]}:</label>  
                    <div className='flex-vertical' onClick={() => state.isEditable ? null : this.modal.openModalInformation()} style={{cursor: isDisableEdit ? 'not-allowed' : 'pointer', width: '100%'}}>
                      <div className='radio-button' style={{ width: '100%' }}>
                        <RadioButton
                          options={optionsMeetingLinkType}
                          language={language}
                          selectedKey={this.state.meetingLinkType}
                          disabled={isDisableEdit}
                          colorTheme={colorTheme}
                          onSelected={(key) => this.setState({ meetingLinkType: key, isOnlineMeeting: key !== MEETING_LINK_TYPE.NONE })} />
                      </div>

                      {this.state.meetingLinkType === MEETING_LINK_TYPE.MANUAL &&
                        <div className='flex-link' style={{ marginTop: '12px' }}>
                          <img src={IMG['ic_link.svg']} alt='ic_link' style={{ width: '24px', height: '24px' }} />
                          <input
                            disabled={isDisableEdit}
                            className='input-body input-link'
                            value={state.meetingLink || ''}
                            placeholder={CREATE_BOOKING.MEETING_LINK_PLACEHOLDER[language]}
                            onChange={this.handleMeetingLinkChange}
                          />
                        </div>
                      }
                    </div>
                  </section>
                  )}

                    {this.repeatBooking()}
                    {this.crashMeetingModal()}
                    {this.editModal()}
                    {this.editRepeatModal()}

                    <section className='content'>
                      <label className='content-header'>{CREATE_BOOKING.NOTIFICATION[language]}:</label>
                      <section className='content-body'>
                        <div style={{ width: '100%', flex: 1 }}>
                          <DropDown2
                            list={NOTIFICATION_LIST[language]}
                            disabled={isDisableEdit}
                            isShowExternalEditModal={!state.isEditable}
                            currentValue={state.notification}
                            className={'number-input ' + (state.isError && state.notification < 0 ? 'notification-list error' : 'notification-list')}
                            handleClick={(event, item, index) => this.selectNotification(item, index)}
                            colorTheme={colorTheme}
                            handleEditModal={this.modal.openModalInformation}
                          />
                        </div>
                      </section>
                    </section>



                    {!isDesk && checkPermission(props.permission, ROUTE.BOOKING.ACTION.CATERING_READ) &&
                      <section className='content' style={{ display: 'block' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <label className='content-header' style={{ width: 'auto', marginBottom: 0, fontSize: '20px', fontWeight: 600, fontFamily: 'NunitoSansSemiBold, sans-serif' }}>{CREATE_BOOKING.CATERING[language]}:</label>
                          {!isDisableEdit && (
                            <span
                              onClick={() => this.showCateringModal()}
                              style={{ color: colorTheme, cursor: 'pointer', fontSize: '16px', fontWeight: 400, fontFamily: 'NunitoSans, sans-serif', userSelect: 'none', textDecoration: 'underline' }}
                            >
                              {CREATE_BOOKING.ADD_CATERING ? CREATE_BOOKING.ADD_CATERING[language] : (language === 'TH' ? 'เพิ่มการจัดเลี้ยง' : 'Add Catering')}
                            </span>
                          )}
                        </div>
                        <section className='content-body'>
                          <div style={{ minHeight: 40 }}>
                            {this.renderSpaceResourceItems(state.orderCatering, state.itemCatering, 'catering', language, isDisableEdit)}
                          </div>
                        </section>
                      </section>
                    }

   
                    {!isDesk && checkPermission(props.permission, ROUTE.BOOKING.ACTION.EQUIPMENT_READ) &&
                      <section className='content' style={{ display: 'block' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <label className='content-header' style={{ width: 'auto', marginBottom: 0, fontSize: '20px', fontWeight: 600, fontFamily: 'NunitoSansSemiBold, sans-serif' }}>{CREATE_BOOKING.EQUIPMENT[language]}:</label>
                          {!isDisableEdit && (
                            <span
                              onClick={() => this.showEquipmentModal()}
                              style={{ color: colorTheme, cursor: 'pointer', fontSize: '16px', fontWeight: 400, fontFamily: 'NunitoSans, sans-serif', userSelect: 'none', textDecoration: 'underline' }}
                            >
                              {CREATE_BOOKING.ADD_EQUIPMENT ? CREATE_BOOKING.ADD_EQUIPMENT[language] : (language === 'TH' ? 'เพิ่มอุปกรณ์' : 'Add Equipment')}
                            </span>
                          )}
                        </div>
                        <section className='content-body'>
                          <div style={{ minHeight: 40 }}>
                            {this.renderSpaceResourceItems(state.orderEquipment, state.itemEquipment, 'equipment', language, isDisableEdit)}
                          </div>
                        </section>
                      </section>
                    }

                  </section>
                </section>

                {state.isShowUnsavedModal && (
                  <ModalConfirm
                    language={language}
                    header={CREATE_BOOKING.UNSAVED_CHANGES_HEADER[language]}
                    contentText={CREATE_BOOKING.UNSAVED_CHANGES_CONTENT[language]}
                    nameButtonOk={CREATE_BOOKING.LEAVE_PAGE[language]}
                    nameButtonCancel={CREATE_BOOKING.STAY_ON_PAGE[language]}
                    onClickAction={this.confirmNavigation}
                    onClickCancel={this.cancelNavigation}
                    colorTheme={colorTheme}
                  />
                )}

                <section className='button-container'>
                  {state.canEdit && getRoomBookingStatus(state.status).isWaiting
                    ? (
                      <Button
                        name={CREATE_DEFAULT.CLEAR[language]}
                        className='btn-back'
                        onClick={() => this.resetState()}
                      />
                    )
                    : null
                  }

                  {showPermission &&
                    <Button
                      name={props.isEditing ? CREATE_DEFAULT.SAVE[language] : CREATE_DEFAULT.SAVE[language]}
                      className={`${state.status === STATUS.END_MEETING ? 'btn-save-disabled' : validated ? 'btn-save-pass ' : 'btn-save'}`}
                      disabled={state.status === STATUS.END_MEETING || state.isDisabledSaveButton}
                      onClick={
                        validated
                          ? () => this.onSubmitBooking(this.prepareParams(), state.isEditing)
                          : () => this.raiseError()
                      }
                    />
                  }

                  {props.isEditing && checkPermission(props.permission, ROUTE.BOOKING.ACTION.UPDATE) &&
                    <Button
                      name={props.isEditing ? CREATE_DEFAULT.SAVE[language] : CREATE_DEFAULT.SAVE[language]}
                      className={`btn-save${validated ? '-pass' : ''}`}
                      disabled={state.isDisabledSaveButton}
                      onClick={
                        validated
                          ? () => this.onSubmitBooking(this.prepareParams(), state.isEditing)
                          : (() => this.raiseError())
                      }
                    />
                  }
                </section>
              </section>
            )
          }
          {!state.isHiding
            ? <RoomTimeline
              language={language}
              bookingList={bookingListRoom}
              handleMoveTimeline={(data) => this.handleMoveTimeline(data)}
              selectedDate={state.selectedDate}
              roomName={state.selectedRoom}
              handleClickTimeline={(stmp) => this.handleClickTimeline(stmp)}
              className={state.isShowRoomTimeline ? 'room-timeline-show' : ''}
              handleClose={() => this.toggleTimeline()}
              username={props.username}
              minuteStep={state.minuteStep}
              startOperatingTime={state.startOperatingTime}
              endOperatingTime={state.endOperatingTime}
              colorTheme={settingReducer.settingTheme.colorTheme}
              startDatetimeHeader={state.selectedDate}
              endDatetimeHeader={state.selectedDate}
            />
            : null
          }
        </section>
        
      </Style>
    )
  }
}

CreateBooking.propTypes = {
  openModalStatus: PropTypes.func,
  closeModalStatus: PropTypes.func,
  language: PropTypes.string,
  username: PropTypes.string,
  minuteStep: PropTypes.number,
  startOperatingTime: PropTypes.string,
  endOperatingTime: PropTypes.string
}

const mapDispatchToProps = dispatch => {
  return {
    modalAction: bindActionCreators(MODAL.action, dispatch),
  }
}

const mapStateToProps = ({ modalReducer, settingReducer, holidayReducer }) => {
  return {
    modalReducer,
    settingReducer,
    listHoliday: holidayReducer.listHoliday,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateBooking)

